import React, { useRef, useState, useEffect } from "react";
import styles from "./AddProject.module.css";
import { AiOutlineClose } from "react-icons/ai";
import TextInput from "../../Components/TextInput/TextInput";
import { connect, useDispatch } from "react-redux";
import { createProject,contactResources } from "../../Services/contacts";
import { createProjectMongo } from "../../Services/projects";
import Dropdown from "../../Components/DropDown/Dropdown";
import Loading from "../../Components/Loading/Loading";
import { showSnackbarAction } from "../../Redux/actions";
import { themeColors } from "../../Components/theme";
import Label from "../../Components/Label";
import { alphabetValidatorProjectName, aphabetValidator, contactValidator } from "../../Values/validatorsnew";
import { Button } from "@material-ui/core";
import { googleAnalytics, googleAnalyticsCTAClick } from "../../Services/users";
const propertyStatus=["INTERMEDIATE","Launched","Not Launch"];
const RentpropertyStatus=["Available","Un-Available"];

const AddProject = ({ history, user, theme, organizationData,constants ,userPreference,authToken,organizationResources}: any) => {
  const dispatcher = useDispatch();
  const projectNameRef: any = useRef();
  const developerNameRef: any = useRef();
  const reraLinkRef: any = useRef();
  const locationRef: any = useRef();
  const ownerNameRef: any = useRef();
  const ownerContactRef: any = useRef();
  const walkthroughLinkRef: any = useRef();
  const addressRef: any = useRef();
  const priceRef: any = useRef();
  const unitRef:any = useRef()
  const [description, setDescription] = useState("");
  const [businessVerticalList, setBusinessVerticalList] = useState<any[]>(
    []
  );


  const [propertyStageSelected, setPropertyStageSelected] = useState<any>({
    label: "",
    value: "",
  });
  const [projectStatusSelected, setProjectStatusSelected] = useState<any>({
    label: "Select",
    value: "",
  });
  const [businessVerticalSelected, setBusinessVerticalSelected] =
  useState<any>({
    label: "Select",
    value: "Select",
  });
  const [propertyStageList, setPropertyStageList] = useState<string[]>([]);


  // useEffect(() => {
  //   let data = ["Ready to move in", "Under Construction"];
  //   setPropertyStages(data);
  // }, []);

  // const propertyStageList:any=[];
  // Object.keys(propertyStage).forEach((key)=>{
  //   propertyStageList.push(propertyStage[key])
  // })
  const [propertySubTypeSelected, setPropertySubTypeSelected] = useState<any>({
    label: "Select",
    value: "",
  });
  const [propertySubTypes, setPropertySubTypes] = useState<string[]>([]);

  const [selectedButton, setSelectedButton] = useState("NEW PROJECT");


  useEffect(() => {
    let data = ["Office", "Mypod", "Vila", "Dupex", "Flat"];
    setPropertySubTypes(data);
  }, []);



  const [propertyTypeSelected, setPropertyTypeSelected] = useState<any>({
    label: "",
    value: "",
  });
  const [propertyTypes, setPropertyTypes] = useState<any[]>([]);
  const [load, setLoad] = useState(false);

  const constant = async() => {
    const propertyStageValues:any = Object.values(constants.propertyStage);
    const propertyTypeValues = Object.values(constants.propertyType);
   setPropertyStageList(propertyStageValues);
   setPropertyTypes(propertyTypeValues)
  };
  useEffect(() => {
    if (constants && constants.propertyStage) {
      constant();
    }
  }, [constants]);

  // useEffect(() => {
  //   const unsub = contactResources(
  //     user.organization_id,
  //     () => {},
  //     () => {},
  //     () => {},
  //     (data) => setBusinessVerticalList(data),
  //     organizationData
  //   );

  //   return () => {
  //     unsub();
  //   };
    // eslint-disable-next-line
  // }, [])

  // console.log("rishabhResource",organizationResources)

  useEffect(()=>{

    if(organizationResources){
      organizationResources.forEach((val:any)=>{
        if(val.resource_type==="businessVertical"){
          let loc:any=[]
          val["businessVertical"].forEach((item:any)=>{
                loc.push(item.businessVertical)
          })
          setBusinessVerticalList(loc);
        }
      })
    }
   
  },[organizationResources])

  // useEffect(() => {
  //   let data = ["Commercial", "Residential"];
  //   setPropertyTypes(data);
  // }, []);


  useEffect(() => {
    window.onbeforeunload = function () {
      return "Are you really want to perform the action?";
    };
  }, []);

  const checkProject = () => {
  if(!organizationData.business_domain || organizationData.business_domain== "Real Estate"){
    const words = description.split(/\s+/);
    if (projectNameRef.current.value === "") {
      dispatcher(showSnackbarAction("Please Enter Project Name", "error"));
      return false;
    }
     else if (developerNameRef.current.value === "") {
      dispatcher(showSnackbarAction("Please Enter Developer Name", "error"));
      return false;
    }
    else if (walkthroughLinkRef.current.value === "") {
      dispatcher(showSnackbarAction("Please Enter Walkthrough Link", "error"));
      return false;
    }
    else if (addressRef.current.value === "") {
      dispatcher(showSnackbarAction("Please Enter Address", "error"));
      return false;
    }
    else if (
      propertyTypeSelected.label === "Select" ||
      propertyTypeSelected.label === ""
    ) {
      dispatcher(showSnackbarAction("Please Enter Property Type", "error"));
      return false;
    }
    else if (
      propertyStageSelected.label === "Select" ||
      propertyStageSelected.label === ""
    ) {
      dispatcher(showSnackbarAction("Please Enter Property Stage", "error"));
      return false;
    }
    else if (
      projectStatusSelected.label === "Select" ||
      projectStatusSelected.label === ""
    ) {
      dispatcher(showSnackbarAction("Please Enter Project Status", "error"));
      return false;
    }
    if(developerNameRef.current.value !== "" && alphabetValidatorProjectName(developerNameRef.current.value) === "Invalid Name"){
      dispatcher(showSnackbarAction("No special character allowed in developer name", "error"));
      return false;
  }
  if(projectNameRef.current.value !== "" && alphabetValidatorProjectName(projectNameRef.current.value) === "Invalid Name"){
    dispatcher(showSnackbarAction("No special character allowed in project name", "error"));
    return false;
}if(description !== ""&& (words.length >= 300)){
      dispatcher(showSnackbarAction("Max 300 words allowed for the description", "error"));
      return false;
}
    else {
      return true;
    }
  }else
  {
    if (projectNameRef.current.value === "") {
      dispatcher(showSnackbarAction("Please Enter Project Name", "error"));
      return false;
    }
    else if(projectNameRef.current.value !== "" && alphabetValidatorProjectName(projectNameRef.current.value) === "Invalid Name"){
      dispatcher(showSnackbarAction("No special character allowed in projects name", "error"));
      return false;
  }
    else if (addressRef.current.value === "") {
      dispatcher(showSnackbarAction("Please Enter Address", "error"));
      return false;
    }
    else if (
      businessVerticalSelected.label === "Select" ||
      businessVerticalSelected.label === ""
    ) {
      dispatcher(showSnackbarAction("Please Enter Business Vertical", "error"));
      return false;
    }
    else {
      return true;
    }
  }
  };

  const checkProjectRental = () => {
    if(!organizationData.business_domain || organizationData.business_domain== "Real Estate"){
      const words = description.split(/\s+/);
      if (unitRef.current.value === "") {
        dispatcher(showSnackbarAction("Please Enter Unit No.", "error"));
        return false;
      }
       else if (priceRef.current.value === "") {
        dispatcher(showSnackbarAction("Please Enter Price", "error"));
        return false;
      }
      else if (ownerContactRef.current.value !=="" && contactValidator(ownerContactRef.current.value)==="Invalid Phone No.") {
        dispatcher(showSnackbarAction("Please Enter valid phone number", "error"));
        return false;
      }
      else if (addressRef.current.value === "") {
        dispatcher(showSnackbarAction("Please Enter Address", "error"));
        return false;
      }else if (
        projectStatusSelected.label === "Select" ||
        projectStatusSelected.label === ""
      ) {
        dispatcher(showSnackbarAction("Please Enter Availability Status", "error"));
        return false;
      }else
      if(description !== ""&& (words.length >= 300)){
        dispatcher(showSnackbarAction("Max 300 words allowed for the description", "error"));
        return false;
  }
      else {
        return true;
      }
    }else
    {
      const words = description.split(/\s+/);
      if (unitRef.current.value === "") {
        dispatcher(showSnackbarAction("Please Enter Unit No.", "error"));
        return false;
      }
       else if (priceRef.current.value === "") {
        dispatcher(showSnackbarAction("Please Enter Price", "error"));
        return false;
      }else
      if(description !== ""&& (words.length >= 300)){
        dispatcher(showSnackbarAction("Max 300 words allowed for the description", "error"));
        return false;
  }
      else {
        return true;
      }
    }
    };

  const create = (e: any) => {
    e.preventDefault();
    setLoad(true);
    let check = false;
    {selectedButton === "NEW PROJECT" ? (check = checkProject()):(check=checkProjectRental())}
    // console.log("check",check)
    if (check === true) {
      if(!organizationData.business_domain || organizationData.business_domain== "Real Estate"){
        createProjectMongo(
        user.organization_id,
        // propertySubTypeSelected.label,
        user.user_first_name + " " + user.user_last_name,
        dispatcher,
        history,
        (data: boolean) => setLoad(data),
        authToken,
        user.uid,
        "",
        projectNameRef?.current?.value.trim(),
        developerNameRef?.current?.value.trim(),
        addressRef?.current?.value,
        propertyStageSelected?.label,
        projectStatusSelected?.label,
        // locationRef.current.value,
        
        // budgetRef.current.value,
        propertyTypeSelected?.label,
        reraLinkRef?.current?.value,
        walkthroughLinkRef?.current?.value,
        ownerNameRef?.current?.value,
        ownerContactRef?.current?.value,
        priceRef?.current?.value,
        unitRef?.current?.value,
        selectedButton,
        description
      )
    }else{
      createProjectMongo(
        user.organization_id,
        
        user.user_first_name + " " + user.user_last_name,
        dispatcher,
        history,
        (data: boolean) => setLoad(data),
        authToken,
        user.uid,
        businessVerticalSelected.label,
        projectNameRef?.current?.value.trim(),
        "",
        addressRef?.current?.value,
        "",
        "",
        "",
        "",
        "",
        ownerNameRef?.current?.value,
        ownerContactRef?.current?.value,
        priceRef?.current?.value,
        unitRef?.current?.value,
        selectedButton,
        description
      )
    }
    } else {
      setLoad(false);
    }
  };

  const capitalizeFirstLetter = (string:any) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }

  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const [isGACalled, setIsGACalled] = useState<any>(false);
 
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Prevent typing 'e', '.', and '-' keys if type is number
    if (e.key === "e" || e.key === "." || e.key === "-") {
      e.preventDefault();
    }
  };
  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('Add_Listings_Screen',user)
      }
    }
  },[user])

  return (
    <div className={styles.parent} style={containerStyles}>
      {load === true && <Loading />}
      
      <div
        // className={styles.headerView}
        className="d-flex flex-row w-100 px-4 pt-4"
      >
        <h5
        // className={styles.heading}
        > Add {capitalizeFirstLetter(selectedButton)} Details</h5>
        <AiOutlineClose
          className={styles.closeIcon}
          size={25}
          onClick={() => history.replace("/projects")}
        />
      </div>
      <div className="d-flex flex-row w-100 px-4">
      <Button 
      variant={selectedButton === "NEW PROJECT" ? "contained" : "outlined"} 
      onClick={() => {
        googleAnalyticsCTAClick("Add New Project","Add Listing Screen",user)
        setSelectedButton("NEW PROJECT")}}
      style={{borderTopLeftRadius:15,
      borderTopRightRadius:15,
      backgroundColor: selectedButton === "NEW PROJECT" ? '#279f9f' : '#fff',
      color:selectedButton === "NEW PROJECT" ? '#fff' : '#279f9f',
      width:"11.5%"}}>
        NEW Project
      </Button>
      <Button 
      variant={selectedButton === "RENTAL" ? "contained" : "outlined"} 
      onClick={() => {
        googleAnalyticsCTAClick("Add Rental","Add Listing Screen",user)
        setSelectedButton("RENTAL")}}
      style={{
        borderTopLeftRadius:15,
        borderTopRightRadius:15,
        backgroundColor: selectedButton === "RENTAL" ? '#279f9f' : '#fff',
        color:selectedButton === "RENTAL" ? '#fff' : '#279f9f',
        width:"11.5%%"}}>
        Rental
      </Button>
      <Button 
      variant={selectedButton === "RESALE" ? "contained" : "outlined"}
      onClick={() => {
        googleAnalyticsCTAClick("Add Resale","Add Listing Screen",user)
        setSelectedButton("RESALE")}}
      style={{borderTopRightRadius:15,
      borderTopLeftRadius:15,
      backgroundColor: selectedButton === "RESALE" ? '#279f9f' : '#fff',
      color:selectedButton === "RESALE" ? '#fff' : '#279f9f',
      width:"11.5%%"}}>
        Resale
      </Button>
    </div>
      <div
        // className={styles.child}
        className="w-100 d-flex flex-column gap-2 px-4"
      // style={cardContainerStyles}
      >
        <form className="card pt-1 pb-4 px-4 shadow rounded pt-4" style={cardContainerStyles}>
          <div className={styles.box2}>
            {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&
            <div className={styles.divide}>
              {selectedButton === "NEW PROJECT" ?<Label label="Developer Name" required={true} />:<Label label="Developer Name" required={false} />}
              <div style={{ width: "150px" }}>
              {selectedButton === "NEW PROJECT" ?
              <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={developerNameRef}
                  validator={alphabetValidatorProjectName}
                ></TextInput>:
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={developerNameRef}
                  // validator={aphabetValidator}
                ></TextInput>}
              </div>
            </div>}
            <div className={styles.divide}>
              {selectedButton === "NEW PROJECT" ?<Label label="Project Name" required={true} />:<Label label="Project Name" required={false} />}
              <div style={{ width: "150px" }}>
                {selectedButton === "NEW PROJECT" ?
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={projectNameRef}
                  validator={alphabetValidatorProjectName}
                ></TextInput>:
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={projectNameRef}
                  // validator={aphabetValidator}
                ></TextInput>
                }
              </div>
            </div>
            {(organizationData.business_domain && organizationData.business_domain !== "Real Estate")&&(
                          <div className={styles.divide}>
                          <Label label="Business Vertical" required={true} />
                          <div style={{ width: "140px", marginRight: "5px" }}>
                            <Dropdown
                              option={businessVerticalList}
                              selectedValue={businessVerticalSelected}
                              setSelectedValue={(value) => {
                                setBusinessVerticalSelected(value);
                              }}
                            />
                            </div>
                        </div>
            )}
            <div className={styles.divide}>
              <Label label="Address" required={true} />
              <div style={{ width: "150px" }}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={addressRef}
                />
              </div>
            </div>
          </div>

          {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&
          <div className={styles.box2}>
            <div className={styles.divide}>
                {selectedButton === "NEW PROJECT" ?<Label label="Property Type" required={true} />:<Label label="Property Type" required={false} />}
                <div style={{ width: "140px", marginRight: "5px" }}>
                  <Dropdown
                    option={propertyTypes}
                    selectedValue={propertyTypeSelected}
                    setSelectedValue={(value) => setPropertyTypeSelected(value)}
                  />
                </div>
            </div>
            {selectedButton==="NEW PROJECT"?<div className={styles.divide}>
              <Label label="Rera Link" required={false} />
              <div style={{ width: "150px" }}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={reraLinkRef}
                />
              </div>
            </div>:
            <div className={styles.divide}>
            <Label label="Owner Name" required={false} />
            <div style={{ width: "150px" }}>
              <TextInput
                title={""}
                style={{ backgroundColor: "#fff" }}
                ref={ownerNameRef}
              />
            </div>
          </div>}
            {selectedButton==="NEW PROJECT"?<div className={styles.divide}>
              <Label label="Walkthrough Link" required={true} />
              <div style={{ width: "150px" }}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={walkthroughLinkRef}
                />
              </div>
            </div>:
            <div className={styles.divide}>
            <Label label="Owner Contact No." required={false} />
            <div style={{ width: "150px" }}>
              <TextInput
                type="number"
                title={""}
                style={{ backgroundColor: "#fff" }}
                ref={ownerContactRef}
                validator={contactValidator}
                minValue={'0'}
                onKeyDown={handleKeyDown}
              />
            </div>
          </div>}
          </div>}
          {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&
          <div className={styles.box2}>
            <div className={styles.divide}>
              {selectedButton === "NEW PROJECT" ?<Label label="Property Stage" required={true} />:<Label label="Property Stage" required={false} />}
              <div style={{ width: "140px", marginRight: "5px" }}>
                <Dropdown
                  option={propertyStageList}
                  selectedValue={propertyStageSelected}
                  setSelectedValue={(value) => setPropertyStageSelected(value)}
                />
              </div>
            </div>
            {selectedButton!=="NEW PROJECT" &&
            <div className={styles.divide}>
            <Label label="Price" required={true} />
            <div style={{ width: "150px" }}>
              <TextInput
              type="number"
                title={''}
                style={{ backgroundColor: "#fff" }}
                ref={priceRef}
                minValue={'0'}
                onKeyDown={handleKeyDown}
              />
            </div>
          </div>}
            <div className={styles.divide}>
              {selectedButton==="NEW PROJECT"?<Label label="Project Status" required={true} />:<Label label="Availability Status" required={true} />}
              <div style={{ width: "140px", marginRight: "5px" }}>
                {selectedButton==="NEW PROJECT"?<Dropdown
                  option={propertyStatus}
                  selectedValue={projectStatusSelected}
                  setSelectedValue={(value) => setProjectStatusSelected(value)}
                />:
                <Dropdown
                  option={RentpropertyStatus}
                  selectedValue={projectStatusSelected}
                  setSelectedValue={(value) => setProjectStatusSelected(value)}
                />}
              </div>
            </div>
            { selectedButton==="NEW PROJECT" &&
              <div className={styles.divide}>
                <Label label="Unit No." required={false} />
                <div style={{ width: "150px" }}>
                  <TextInput
                    title={""}
                    style={{ backgroundColor: "#fff" }}
                    ref={unitRef}
                  />
                </div>
              </div>
          }
          </div>}
          { selectedButton!=="NEW PROJECT" &&
            <div className={styles.box2}>
              <div className={styles.divide}>
                <Label label="Unit No." required={true} />
                <div style={{ width: "150px" }}>
                  <TextInput
                    title={""}
                    style={{ backgroundColor: "#fff" }}
                    ref={unitRef}
                  />
                </div>
              </div>
            </div>
          }
          <div className={styles.box2}>
            <div
              // className={styles.divide}
              style={{ width: "100%" }}
            >
              <Label label="Description" required={false} />
              <div>
                <textarea
                  // style={{
                  //   marginTop: "1rem",
                  // }}
                  className="form-control"
                  rows={2}
                  placeholder={""}
                  // ref={noteRef}
                  onChange={(e) => setDescription(e.target.value)}
                  value={description}
                ></textarea>
              </div>
            </div>
          </div>
          <button className={styles.button} onClick={(e: any) => {
            if(userPreference.project_create_approved === false){
              e.preventDefault()
              dispatcher(
                showSnackbarAction(
                  "You are not allowed to add project. Please contact your admin",
                  "error"
                )
              )
            }
            else{
              create(e)
            }}}>
            Submit
          </button>
        </form>
      </div>


    </div>

  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
    organizationData: state.organization.organizationData,
    constants:state.constants.data,
    userPreference:state.userPreference.data,
    authToken: state.user.authToken,
    organizationResources:state.organizationResources.data
  };
};

export default connect(mapStateToProps)(AddProject);
